import * as React from 'react';
import { Popup, Circle } from 'react-leaflet';
import AddPoiForm from 'components/Layout/Form/AddPoiForm';
import * as POIModule from 'Modules/POIModule';
import { store } from 'Redux/Store';
type AddPOIP = {
    popupPosition?: {
        lat: number;
        lng: number;
    };
    onClose: () => void;
    onDelete?: () => void;
    currentAddress?: string;
    onSubmit: any;
    editable?: boolean;
    initialValues?: POIModule.Types.PointOfInterestDto;
};

export const AddPOI = (props: AddPOIP) => {
    const state = store.getState().form.addPoiForm && store.getState().form.addPoiForm.values ? store.getState().form.addPoiForm.values.radiusMeters : null;

    if (props.popupPosition) {
        return (
            <>
                <Circle center={props.popupPosition} radius={state ? state : 100} />
            </>
        );
    } else {
        return null;
    }
};

export const AddPOITool = (props: AddPOIP) => {
    const {initialValues} = props;
    if (props.editable) {
        return (
            <AddPoiForm initialValues={initialValues} {...{ onClose: () => props.onClose(), onDelete: () => props.onDelete() }} onSubmit={props.onSubmit} />
        );
    } else {
        return (
            <AddPoiForm initialValues={{ address: props.currentAddress, radiusMeters: 100 }} {...{ onClose: () => props.onClose() }} onSubmit={props.onSubmit} />
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/AddPoi.tsx